"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primary = require("./primary");

var _secondary = require("./secondary");

var _excluded = ["variation"];
var MAP = {
  primary: _primary.PrimaryTag,
  secondary: _secondary.SecondaryTag
};

var Tag = function Tag(props) {
  var variation = props.variation,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var Component = MAP[variation];
  return /*#__PURE__*/_react.default.createElement(Component, rest);
};

exports.Tag = Tag;
var variation = ['primary', 'secondary'];
Tag.modes = {
  variation: variation
};
Tag.MAP = MAP;
Tag.propTypes = {
  variation: (0, _propTypes.oneOf)(variation)
};
Tag.defaultProps = {
  variation: 'primary'
};